

export default (Vue , options = {})=>{
    require('intersection-observer');
    const intersectionObserver = new IntersectionObserver((entries) => {
        entries.forEach((item) => {
            if (item.isIntersecting) {
                let image = new Image();
                image.src = item.target.dataset.src;
                image.onload = function(){
                    item.target.src = item.target.dataset.src;
                    // item.target.style.width = 'auto'
                }
                image.onerror = function(){
                    console.log('image url invalid')
                }
                
                // 替换成功后，停止观察该dom
                intersectionObserver.unobserve(item.target);
            }
        })
      }, {
          rootMargin: "20px 0px" // 提前150px进入可视区域时就加载图片，提高用户体验
        });
    //Vue 指令最终的方法
    const addListener = (ele,binding) =>{
        ele.setAttribute('data-src', binding.value)
        ele.src = ele.dataset.default
        intersectionObserver.observe(ele)
    }

    Vue.directive('lazysrc',{
        inserted:addListener,
        // update:addListener
    })
}